import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import DashboardPage from './pages/DashboardPage';
import SignInScreen from './pages/SignupPage/SignupPage';
import ProtectedLayout from './layout/protectedLayout';
import SchemaDisplayPage from './pages/SchemaDisplayPage/SchemaDisplayPage';
import { useAuth } from 'react-oidc-context';
import { setOidcUser } from './rtk/auth/tokenManager';

function PrivateRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    sessionStorage.setItem('postLoginRedirect', location.pathname + location.search);
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  const auth = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);

  function LogoutPage() {
    const auth = useAuth();

    useEffect(() => {
      auth.removeUser().then(() => {
        window.location.replace('/');
      });
    }, [auth]);

    return <div>Logging out...</div>;
  }

  if (auth.user) setOidcUser(auth.user);

  useEffect(() => {
    if (auth.user) setOidcUser(auth.user);
  }, [auth.user]);

  useEffect(() => {
    if (auth.isAuthenticated) {
      sessionStorage.removeItem('postLoginRedirect');
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (auth.isAuthenticated && !auth.user) {
      auth.signinSilent().catch(() => {
        auth.removeUser().then(() => window.location.reload());
      });
    }
  }, [auth]);

  if (auth.isLoading && !auth.user) return null;

  return (
    <BrowserRouter>
      <Routes>
        {/* Public login route */}
        <Route
          path="/"
          element={
            auth.isAuthenticated ? (
              <Navigate to={sessionStorage.getItem('postLoginRedirect') || '/dashboard'} replace />
            ) : (
              <SignInScreen auth={auth} isSigningIn={isSigningIn} setIsSigningIn={setIsSigningIn} />
            )
          }
        />

        {/* SCHEMA ROUTE */}
        <Route
          path="/lab/releases/:version.schema.json"
          element={
            <PrivateRoute>
              <SchemaDisplayPage />
            </PrivateRoute>
          }
        />

        {/* Protected layout routes */}
        <Route
          element={
            <PrivateRoute>
              <ProtectedLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard/*" element={<DashboardPage />} />
        </Route>

        <Route path="/logout" element={<LogoutPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
